import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface BigNumberProps {
	label: string;
	value: string;
	sub?: ReactNode;
	foot?: ReactNode;
	/** Render the value in the indigo accent color for the hero's lead stat. */
	accent?: boolean;
}

/**
 * The oversized numeric card at the top of the Overview page. Uses Inter at
 * 600 with tight letter-spacing and `tabular-nums` so columns of numbers
 * line up without introducing a second font family (per handoff §8).
 */
export function BigNumber({ label, value, sub, foot, accent }: BigNumberProps) {
	return (
		<div className="rounded-lg border border-[#e5e7eb] bg-white px-6 py-5" data-testid="big-number">
			<div className="text-[11px] font-medium uppercase tracking-[0.08em] text-[#9ca3af]">
				{label}
			</div>
			<div
				className={cn(
					"mt-2 text-[44px] font-semibold leading-none tracking-tight tabular-nums",
					accent ? "text-[#4f46e5]" : "text-[#1e1e20]",
				)}
				data-testid="big-number-value"
			>
				{value}
			</div>
			{sub && <div className="mt-3 text-[13px] leading-relaxed text-[#1e1e20]">{sub}</div>}
			{foot && <div className="mt-1.5 text-xs text-[#6b7280]">{foot}</div>}
		</div>
	);
}
